<div class="flex h-full w-full flex-col gap-1">
  <span class="font-bold">{{ label() }}</span>
  <div class="relative cursor-pointer">
    <input
      #inputElement
      class="text-theme-gray border-theme-secondary-gray hover:bg-theme-gray-400 placeholder:text-theme-black text-md h-full w-full rounded border p-2 outline-none"
      [ngClass]="{
        'border-theme-secondary-gray': !isInvalid(),
        'border-error': isInvalid(),
        'bg-theme-gray-400 cursor-not-allowed opacity-60': isDisabled(),
        'bg-theme-gray-400 ring-error ring-1': isOpened() && isInvalid(),
        'bg-theme-gray-400 ring-theme-secondary-gray ring-1': isOpened() && !isInvalid(),
      }"
      #datePickerDirective="dpDayPicker"
      [id]="name()"
      [name]="name()"
      [formControl]="internalControl"
      [dpDayPicker]="datePickerConfig"
      [placeholder]="placeholderText()"
      (close)="closeEvent.emit(); isOpened.set(false)"
      (focus)="focusEvent.emit($event)"
      (open)="onDatePickerOpen(); isOpened.set(true)"
      (click)="clicked.emit()" />
    <span
      class="pointer-events-none absolute top-0 right-2 bottom-0 flex cursor-pointer items-center justify-center"
      [ngClass]="{ 'cursor-pointer': !isDisabled() }">
      <span class="material-icons" style="color: #3b3b3b">calendar_today</span>
    </span>
  </div>
  @if (isInvalid() && errorText()) {
    <span class="text-error" [innerHTML]="errorText()"></span>
  }
</div>
